import {
  PROFILES,
  RoutesKeys,
  SCREENING_SEARCHES,
  CREATE_TEST_GROUP,
  HOME,
  TESTS,
  RESET_TEST_GROUP,
  CREATE_ABM_TESTGROUP_SCREENING,
  CREATE_EVALUATION,
  WORKSPACE,
  CONFIGURATION,
  CONFIGURATION_MEMBERS,
  PLANS_CONSUMPTIONS,
  JOB_POST,
  NOTIFICATIONS,
  USERS_SUMMARY,
  CUSTOM_EMAILS,
  BULK_UPDATE_TESTS,
  CHAT,
  ALKYMATION,
  INTEGRATIONS,
} from './routes';
import profilesIcon from '../assets/sidebar/icons/ProfilesIcon';
import chartIcon from '../assets/sidebar/icons/Chart';
import homeIcon from '../assets/sidebar/icons/Home';
import WorkspaceIcon from '../assets/sidebar/icons/WorkspaceIcon';
import ConfigIcon from '../assets/cardWorkspace/ConfigIcon';
import JobBagIcon from '../assets/sidebar/icons/JobBag';
import CreateEvaluationIcon from '../assets/sidebar/icons/CreateEvaluationIcon';
import CreateEvaluationWithAI from '../assets/sidebar/icons/CreateEvaluationWithAI';
import CandidatesIcon from '../assets/sidebar/icons/CandidatesIcon';
import EvaluationsIcon from '../assets/sidebar/icons/EvaluationsIcon';
import Members from '../assets/sidebar/icons/Members.svg';
import Notifications from '../assets/sidebar/icons/Notifications.svg';
import CustomEmails from '../assets/sidebar/icons/CustomEmails.svg';
import Personalization from '../assets/sidebar/icons/Personalization.svg';
import PlansConsumption from '../assets/sidebar/icons/PlansConsumption.svg';
import { PlanFeaturesIds } from './enums';
import AlkyMationIcon from '../assets/sidebar/icons/AlkyMationSideBar';
import IntegrationIcon from '../assets/sidebar/icons/IntegrationIcon.svg';

const sidebarRoutes = [
  {
    key: RoutesKeys.WORKSPACE,
    path: WORKSPACE,
    label: 'WORKSPACE',
    hide: true,
    icon: WorkspaceIcon,
  },
  {
    key: RoutesKeys.HOME,
    path: HOME,
    label: 'HOME',
    hide: true,
    icon: homeIcon,
  },
  {
    key: RoutesKeys.SCREENING_INVITATIONS,
    label: 'MENU_ITEM_SCREENING',
    path: SCREENING_SEARCHES,
    hide: false,
    subRoutes: [
      {
        label: 'CHAT_DRAFTS_TITLE',
        path: CHAT,
        track: 'create-evaluation-chat-sidebar',
        hide: false,
        icon: <CreateEvaluationWithAI size={25} />,
      },
      {
        label: 'MENU_ITEM_CREATE_EVALUATION',
        path: CREATE_EVALUATION,
        workspaceRoles: ['OWNER', 'ADMINISTRATOR'],
        track: 'create-evaluation-sidebar',
        icon: CreateEvaluationIcon,
      },
      {
        label: 'MENU_ITEM_SEARCHES',
        path: SCREENING_SEARCHES,
        track: 'searches-dashboard',
        icon: EvaluationsIcon,
      },
      {
        label: 'CANDIDATES',
        path: USERS_SUMMARY,
        workspaceRoles: ['OWNER', 'ADMINISTRATOR'],
        track: 'dashboard-candidates',
        icon: CandidatesIcon,
      },
      {
        label: 'MENU_ITEM_TESTS',
        path: TESTS,
        track: 'tests',
        icon: chartIcon,
      },
    ],
  },
  {
    key: RoutesKeys.PROFILES,
    label: 'COMMUNITY_ALKEMY',
    icon: profilesIcon,
    featureId: PlanFeaturesIds.MARKETPLACE,
    path: PROFILES,
  },
  {
    key: RoutesKeys.ALKYMATION,
    label: 'ALKEMY_FLOW',
    icon: AlkyMationIcon,
    featureId: PlanFeaturesIds.ALKYMATION,
    path: ALKYMATION,
  },
  {
    key: RoutesKeys.CREATE_ABM_TESTGROUP_SCREENING,
    label: 'ABM_TESTGROUP_SCREENING',
    path: CREATE_ABM_TESTGROUP_SCREENING,
    icon: chartIcon,
  },
  {
    key: RoutesKeys.CREATE_TEST_GROUP,
    path: CREATE_TEST_GROUP,
    label: 'MENU_ITEM_CREATE_TEST_GROUP',
    icon: chartIcon,
  },
  {
    key: RoutesKeys.BULK_UPDATE_TESTS,
    path: BULK_UPDATE_TESTS,
    label: 'MENU_ITEM_CREATE_TEST_GROUP',
    icon: chartIcon,
  },
  {
    key: RoutesKeys.RESET_TEST_GROUP,
    path: RESET_TEST_GROUP,
    label: 'MENU_ITEM_RESET_TEST_GROUP',
    icon: chartIcon,
  },
  {
    key: RoutesKeys.JOB_POST,
    path: JOB_POST,
    label: 'JOB_POST',
    icon: JobBagIcon,
  },
  {
    key: RoutesKeys.CONFIGURATION,
    label: 'CONFIGURATION_PAGE_BANNER',
    path: CONFIGURATION_MEMBERS,
    hide: false,
    icon: <ConfigIcon width="20" height="20" />,
    workspaceRoles: ['OWNER', 'ADMINISTRATOR'],
    subRoutes: [
      {
        label: 'MENU_ITEM_MEMBERS',
        path: CONFIGURATION_MEMBERS,
        icon: Members,
      },
      {
        label: 'MENU_ITEM_PERSONALIZATION',
        path: CONFIGURATION,
        icon: Personalization,
      },
      {
        label: 'MENU_ITEM_PLANS_CONSUMPTION',
        path: PLANS_CONSUMPTIONS,
        icon: PlansConsumption,
      },
      {
        label: 'NOTIFICATIONS',
        path: NOTIFICATIONS,
        icon: Notifications,
      },
      {
        label: 'CUSTOM_EMAILS',
        path: CUSTOM_EMAILS,
        icon: CustomEmails,
        workspaceRoles: ['OWNER', 'ADMINISTRATOR'],
        track: 'dashboard-emails',
      },
      {
        label: 'INTEGRATIONS',
        path: INTEGRATIONS,
        track: 'integrations',
        icon: IntegrationIcon,
      },
    ],
  },
];

export default sidebarRoutes;
